import React from 'react';
import PageLayout from '../../components/common/page-layout';
import Grid from '@mui/material/Grid';
import ActionCard from '../../components/common/action-card';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ProformasTable from '../../components/tables/proformas-table';
import { Typography } from '@mui/material';

export default function Sales() {
  return (
    <PageLayout pageTitle="فروش">
      <Grid container spacing={3} sx={{ mb: 10 }} justifyContent="center">
        <Grid item xs={12} md={6} lg={3}>
          <ActionCard name="طرف‌های حساب" icon={<SystemUpdateAltIcon />} path="/sales/firms" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <ActionCard name="‌سفارش‌ها" icon={<ListAltIcon />} path="/sales/invoices" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <ActionCard name="فروش امانی" icon={<ListAltIcon />} path="/registery/lendings" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}></Grid>

        <Grid item xs={12} md={8}>
          <Typography variant="h6" lineHeight={3}>
            سفارش‌های جاری
          </Typography>
          <ProformasTable onlyActives={true} />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
